import React from 'react';
import ProfileWithDocView from './ProfileWithDocView';
import AddManualInputModal from './AddManualInputModal';
import AddDocModal from './AddDocModal';
import axios from 'axios';
import { Button } from '@mui/material';
import ExtractionResultModal from './ExtractionResultModal';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';

const DOC_SCANNER_URL = 'https://docscan.orgasvcs.com/api';
const DOC_SCANNER_SERVICES_URL = 'https://docscan.orgasvcs.com/api/services';
const DOC_SCANNER_API_KEY = 'rSjR34vOarKD3i_FacijF8qWIskgUpqC-fay7ovj9uCpypIjyuoR7A';

// Create a separate axios instance for external API calls without interceptors
const externalAxios = axios.create({ withCredentials: false }); // Disable credentials for external API

class AnyDocContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      docFields: {},
      docErrors: {},
      docData: null,
      docScanned: null,
      markedItems: [],
      manualInput: {},
      addedFields: {},
      removedFields: {},
      userCorrections: {},
      // sessionId: 204,
      sessionId: null,
      isEditable: null,
      docNotes: '',
      loadingDoc: false,
      isIterated: false,
      iteratedData: null,
      orginalDocData: null, 
      editedDocScanned: null, 
      editedFields: {},
      docPrompts: [],
      selectedDoc: null,
      extractionResultFields: {},
      extractionResultErrors: {},
    };
  }

  componentDidMount() {
    this.fetchDocPrompt();
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.stopExtractionPolling();
  }

  handleOpen = (modal) => {
    this.setState({ modal });
  };

  handleClose = () => {
    this.setState({ modal: false, });
  };

  onChangeDoc = (e) => {
    let value = e.target.value;
    this.setState((prevState) => ({
      docFields: {
        ...prevState.docFields,
        [e.target.name]: e.target.name === 'file' ? e.target.files[0] : value
      }
    }));
  };

  validateDoc = () => {
    const docFields = { ...this.state.docFields };
    const error = {};
    let formValid = true;
    if (!docFields.name || (docFields.name.trim().length === 0)) {
      formValid = false;
      error.name = 'Enter filename.';
    }
    if (!docFields.file) {
      formValid = false;
      error.remark = 'Select a file.';
    }
    this.setState({ docErrors: error });
    return formValid;
  };
  
  addDoc = async () => {
    const formData = new FormData();
    Object.entries(this.state.docFields || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    if (this.state.selectedDoc) {
      formData.append('prompt_id', this.state.selectedDoc);
    }

    const link = `${DOC_SCANNER_SERVICES_URL}/uni-doc?service_type=UNI-DOC`;
    
    for (const [k, v] of formData.entries()) {
      console.log('UPLOAD FIELD:', k, v);
    }
    try {
      const response = await externalAxios.post(link, formData, {
        headers: {
          'X-API-KEY': DOC_SCANNER_API_KEY,
          'Content-Type': 'multipart/form-data',
        },
        
      });
      console.log('DOC SCAN RESPONSE', response.data);
      if(response){
        this.setState({
          docData: response.data,
          modal: false,
        }, () => {
          console.log(this.state.docData,'docdata');
          alert('Document scanned successfully!');
          this.startRequestStatusPolling(); // Start polling after successful scan
        });
      } else {
        alert('Failed to scan document. Please try again.');
      }
    } catch (error) {
      // Error handling
      if (error.response) {
        // Server responded with a status outside 2xx range
        console.error('DOC SCAN ERROR DATA:', error.response.data);
        console.error('DOC SCAN ERROR STATUS:', error.response.status);
      } else {
        console.error('DOC SCAN ERROR MESSAGE:', error.message);
      }
    }
  };

  startRequestStatusPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }

    const pollRequestStatus = async () => {
      const status = await this.requestStatus(); // Initial call
      if (status) {
        this.setState({ loadingDoc: true });
      }
      if (status && status.toLowerCase() === 'complete') {
        clearInterval(this.interval);
        this.interval = null;
        this.setState({ loadingDoc: false });
        console.log('Interval stopped.');
      }
    };

    pollRequestStatus();
    this.interval = setInterval(pollRequestStatus, 10000);
  
  };

  requestStatus = async () => {
    console.log('in requestStatus');
    let docData = { ...this.state.docData };
    let serviceRequestId = docData.serviceRequestId;

    if (!serviceRequestId) {
      alert('Service request ID is missing. Please scan a document first.');
      return;
    }

    console.log(docData, 'formData-inaddDoc');

    const link = `${DOC_SCANNER_SERVICES_URL}/request-status?service_request_id=${serviceRequestId}`;
    console.log(link,'link- addDoc');

    try {
      const response = await externalAxios.post(link, null, {
        headers: {
          'X-API-KEY': DOC_SCANNER_API_KEY,
          hideloader: true 
        } 
      });
      console.log('DOC SCAN RESPONSE', response);
      const extractedData = response?.data?.data || null;
      const originalFields = response?.data?.data?.pages?.[0]?.data?.fields || null;
      const sessionIdFromResponse = extractedData?.pages?.[0]?.session_id || null;

      this.setState({ 
        orginalDocData: originalFields ? JSON.parse(JSON.stringify(originalFields)) : null,
        docScanned: extractedData,
        sessionId: sessionIdFromResponse || this.state.sessionId,
        // sessionId: sessionIdFromResponse || this.state.sessionId,
      }, () => { {
        this.handleEditDoc();
      }

      });
      console.log('DOC SCAN RESPONSE', response.data);
      
      return response.data.status;
    } catch (error) {
      console.log('ERROR', 'DOC SCAN ERROR', error);
      return null;
    }
  };

  handleClearField = (field, value) => {
    console.log('handleClearField called');
    this.setState((prevState) => ({
      isEditable: null,
      removedFields: {
        ...prevState.removedFields,
        [field]: value,
      },
    }), () => {
      console.log(this.state.removedFields, 'removedFields');
    });
  };

  sanitizeMap = (input) => {
    return Object.entries(input || {}).reduce((acc, [key, value]) => {
      const cleanKey = String(key || '').trim();
      const cleanValue = String(value || '').trim();
      if (cleanKey && cleanValue) {
        acc[cleanKey] = cleanValue;
      }
      return acc;
    }, {});
  };

  submitFeedback = async ({ sessionId, feedbackData }) => {
    const normalizedSessionId = Number(sessionId);
    if (!Number.isFinite(normalizedSessionId)) {
      alert('Invalid session ID. Please fetch request status again.');
      return;
    }

    const link = `${DOC_SCANNER_URL}/extractions/${normalizedSessionId}/feedback`;
    const response = await externalAxios.post(link, feedbackData, {
      headers: {
        'X-API-KEY': DOC_SCANNER_API_KEY,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    return response;
  };

  revertMarked = (data) => {
    const docScanned = { ...this.state.docScanned };
    const removedFields = { ...this.state.removedFields };
    if(removedFields[data?.label]){
      delete removedFields[data?.label];
    }
    this.setState({
      docScanned,
      removedFields
    });
  };

  handleEditDoc = () => {
    const editedDocScanned = { ...this.state.docScanned };
    
    if(this.state.editedFields && Object.keys(this.state.editedFields).length > 0){
      Object.entries(this.state.editedFields).forEach(([key, value]) => {
        if (editedDocScanned && editedDocScanned.pages && Array.isArray(editedDocScanned.pages)) {
          editedDocScanned.pages.forEach((page) => {
            const match =  Object.entries(page.data?.fields || {}).find(([ , v]) => v?.label === key);
            
            if (page.data && page.data.fields && page.data.fields[match?.[0]]) {
              page.data.fields[match[0]].value = value;
            }
          });
        }
      });
    }

    this.setState({ editedDocScanned: editedDocScanned });
  };

  onSave = async () => {
    // const { docScanned } = this.state; //dnd
    const { sessionId, addedFields, removedFields, docNotes, userCorrections } = this.state;

    if (!sessionId) {
      alert('Session ID is missing. Please scan a document first.');
      return;
    }

    const feedbackData = {
      originalExtraction: this.state.orginalDocData || {},
      userCorrections: this.sanitizeMap(userCorrections || {}),
      addedFields: this.sanitizeMap(addedFields),
      removedFields: this.sanitizeMap(removedFields),
      userNotes: docNotes || '',
    };
    console.log('Submitting feedback:', feedbackData);

    //dnd
    try {
      const response = await this.submitFeedback({
        sessionId,
        feedbackData,
      });

      this.startExtractionPolling(); // Start polling after feedback submission

      console.log('Feedback submission response:', response.data);
      alert('Feedback submitted successfully!');
      // this.setState({
      //   addedFields: {},
      //   removedFields: {},
      //   docNotes: '',
      //   userCorrections: {}, 
      //   editedFields: {}, // New state for edited document data
      // });
    } catch (error) {
      if (error.response) {
        console.error('DOC SCAN ERROR DATA:', error.response.data);
        console.error('DOC SCAN ERROR STATUS:', error.response.status);
      } else {
        console.error('DOC SCAN ERROR MESSAGE:', error.message);
      }
      alert('Failed to submit feedback. Please try again.');
    }
  };
  // notes 
  onChangeTextField = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, });
  };  

  // manualInput 
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      manualInput: {
        ...prevState.manualInput,
        [name]: value,
      },
    }));
  };

  handleEditField = (field, pageIndex, key) => {
    this.setState(() => ({ isEditable: `${pageIndex}-${key}` }));
  };
  
  onChangeValue = (e, pageIndex, key) => {
    console.log(pageIndex, key, 'pageIndex and key in onChangeValue');
    const { value, name } = e.target;
    this.setState({
      editedFields: { [name]: value },
      // editedDocScanned 
    }, () => {
      this.handleEditDoc();      
    });
  };


  handleAddField = (e) => {
    e.preventDefault();
    const { label = '', value = '' } = this.state.manualInput || {};
    const normalizedLabel = String(label).trim();
    const normalizedValue = String(value).trim();

    if (!normalizedLabel || !normalizedValue) {
      alert('Please fill in both Label and Reference Value fields.');
      return;
    }

    this.setState((prevState) => ({
      addedFields: {
        ...prevState.addedFields,
        [normalizedLabel]: normalizedValue,
      },
      manualInput: {
        label: '',
        value: '',
        notes: '',
      },
    }));
  };

  handleDeleteField = (label, value) => {
    this.setState((prevState) => ({
      removedFields: {
        ...prevState.removedFields,
        [label]: value,
      },
    }));
  };

  handleSaveValue = (field, value) => {
    console.log('handleSaveValue called');
    this.setState((prevState) => ({
      isEditable: null,
      userCorrections: {
        ...prevState.userCorrections,
        [field]: value,
      },
    }), () => {
      console.log(this.state.userCorrections, 'userCorrections');
    });
  }; 

  fetchExtractedData = async () => {
    const { sessionId } = this.state;
    if (!sessionId) {
      alert('Session ID is missing. Please scan a document first.');
      return null;
    }

    const link = `${DOC_SCANNER_URL}/extractions/${sessionId}`;

    try {
      const response = await externalAxios.get(link, {
        headers: {
          'X-API-KEY': DOC_SCANNER_API_KEY,
          hideloader: true 
        }, 
      });
      this.setState({ docScanned: response?.data?.data || null });
      const extractionStatus = response?.data?.currentStatus || null;

      return extractionStatus;
    } catch (error) {
      console.error('Error fetching extracted data:', error);
      alert('Failed to fetch extracted data. Please try again.');
      return null;
    }
  };

  fetchExtractedDataIteration = async () => {
    const { sessionId } = this.state; 
    if (!sessionId) {
      alert('Session ID is missing. Please scan a document first.');
      return null;
    }

    const link = `${DOC_SCANNER_URL}/extractions/${sessionId}/iterations`;

    try {
      externalAxios.get(link, {
        headers: {
          'X-API-KEY': DOC_SCANNER_API_KEY,
          hideloader: true 
        },  
      })
        .then(response => {
          if(response?.status === 200){
            this.setState({ isIterated: true });
          }
        })
        .catch(error => {
          console.error('Error fetching doc prompts:', error);
          alert('Failed to fetch doc prompts. Please try again.');
        });
      // const iterations = response?.data?.iterations || [];
      // const lastIteration = iterations.length - 1;
      // const latestIteration = iterations?.[lastIteration] || {};
      // const iterationPages = latestIteration?.testResults?.incorrect?.pages?.actual || null;

      // if (Array.isArray(iterationPages) && iterationPages.length > 0) {
      //   console.log('IterationPages', iterationPages);
      //   this.setState((prevState) => ({
      //     docScanned: {
      //       ...(prevState.docScanned || {}),
      //       // pages: iterationPages,
      //     },
      //     // iteratedData: null,
      //     // isIterated: true,
      //   }));
      //   return null;
      // }
      // console.warn('No iteration pages/fields found in latest iteration.');
      return null;
    } catch (error) {
      console.error('Error fetching extracted data:', error);
      alert('Failed to fetch extracted data. Please try again.');
      return null;
    }
  };

  startExtractionPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }

    const pollExtractionStatus = async () => {
      const status = await this.fetchExtractedData(); // Initial call
      if (status) {
        this.setState({ loadingDoc: true });
      }
      const normalizedStatus = String(status || '').trim().toLowerCase();
      if (normalizedStatus === 'testing' || normalizedStatus === 'failed') {
        clearInterval(this.interval);
        this.interval = null;
        this.setState({ loadingDoc: false });

        //fetch iteration data
        this.fetchExtractedDataIteration();
      }
    };

    pollExtractionStatus();
    this.interval = setInterval(pollExtractionStatus, 30000);
  };

  
  stopExtractionPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };

  handleApproveExtraction = async () => {
    const { sessionId } = this.state;
    if (!sessionId) {
      alert('Session ID is missing. Please scan a document first.');
      return null;
    }
    const link = `${DOC_SCANNER_URL}/extractions/${sessionId}/approve`;
    let formdata = { ...this.state.extractionResultFields };
    try {
      const response = await externalAxios.post(link, formdata, { headers: { 'X-API-KEY': DOC_SCANNER_API_KEY, }, });
      console.log('Fetched extracted data:', response.data);
      this.setState({ extractionResultFields: {} });
    } catch (error) {
      console.error('Error fetching extracted data:', error);
      alert('Failed to fetch extracted data. Please try again.');
      this.setState({ extractionResultFields: {} });
    }
  };

  handleRejectExtraction = async () => {
    const { sessionId } = this.state;
    if (!sessionId) {
      alert('Session ID is missing. Please scan a document first.');
      return null;
    }
    const link = `${DOC_SCANNER_URL}/extractions/${sessionId}/reject`;
    let formdata = { ...this.state.extractionResultFields };

    try {
      const response = await externalAxios.post(link, formdata, { headers: { 'X-API-KEY': DOC_SCANNER_API_KEY, }, });
      console.log('Fetched extracted data:', response.data);
      this.setState({ extractionResultFields: {} });
    } catch (error) {
      console.error('Error fetching extracted data:', error);
      alert('Failed to fetch extracted data. Please try again.');
      this.setState({ extractionResultFields: {} });
    }
  };
  // Prompt fetching function
  fetchDocPrompt = () => {
    const link = `${DOC_SCANNER_URL}/admin/document-prompts?active_only=false&limit=100&offset=0`;

    externalAxios.get(link, {
      headers: {
        'X-API-KEY': DOC_SCANNER_API_KEY,
        Accept: 'application/json',
      }, 
    })
      .then(response => {
        if (response?.status === 200) {
          let isActivePrompts = response?.data?.prompts?.filter((item) => item.is_active === true);
          this.setState({ docPrompts: isActivePrompts || [] });
        }
      })
      .catch(error => {
        console.error('Error fetching doc prompts:', error);
        alert('Failed to fetch doc prompts. Please try again.');
      });
  };

  handleDocSelectionChange = (selectedDoc) => {
    this.setState({ selectedDoc });
  };

  handleRemoveField = (label) => {
    this.setState((prevState) => {
      const updatedAddedFields = { ...prevState.addedFields };
      delete updatedAddedFields[label];
      return { addedFields: updatedAddedFields };
    });
  };

  onChangeExtractionResult = (e) => {
    let { value, name } = e.target;
    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }
    this.setState((prevState) => ({
      extractionResultFields: {
        ...prevState.extractionResultFields,
        [name]: value 
      }, 
    }));
  };
  validation = (type) => {
    const fields = { ...this.state.extractionResultFields };
    const error = {};
    let formValid = true;
    if(type === 'accept'){
      if (!fields.name || (fields.name.trim().length === 0)) {
        formValid = false;
        error.name = 'Name should not be empty';
      }
      if (!fields.notes || (fields.notes.trim().length === 0)) {
        formValid = false;
        error.notes = 'Notes should not be empty';
      }
    }
    if (type === 'reject') {
      if (!fields.reason || (fields.reason?.trim().length === 0)) {
        formValid = false;
        error.reason = 'Reason should be minimum 2 characters';
      }
    }
    
    this.setState({ extractionResultErrors: error });
    return formValid;
  };

  onSubmitResult = (type) => {
    if (type === 'approve') {
      this.handleApproveExtraction();
    } else if (type === 'reject') {
      this.handleRejectExtraction();
    }
  };

  onDeleteDocPrompt = (promptId) => {
    const link = `${DOC_SCANNER_URL}/admin/document-prompts/by-id/${promptId}?permanent=false&force=true`;

    externalAxios.delete(link, { headers: { 'X-API-KEY': DOC_SCANNER_API_KEY, }, })
      .then(response => {
        console.log('Document prompt deleted:', response.data);
        this.props.setDelete();
        this.fetchDocPrompt(); // Refresh the list after deletion
      })
      .catch(error => {
        console.error('Error deleting document prompt:', error);
        alert('Failed to delete document prompt. Please try again.');
      });
  };

  handleDeleteDocPrompt = (promptId, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id: promptId,
      anchorEl,
      onConfirm: () => this.onDeleteDocPrompt(promptId),
    });
  };
  

  render() {
    return (
      <>
        <Button variant='contained' onClick={this.fetchDocPrompt}>DOC Prompt</Button>    
        <Button variant='contained' onClick={this.requestStatus}>Request status{this.state.sessionId}</Button>
        <Button variant='contained' onClick={this.fetchExtractedDataIteration}>fetch Extracted Data</Button>

        <ProfileWithDocView 
          selectedDoc={this.state.selectedDoc}
          handleDocSelectionChange={this.handleDocSelectionChange}
          modal={this.state.modal} 
          handleOpen={this.handleOpen} 
          docData={this.state.docData}
          docScanned={this.state.docScanned}
          handleClearField={this.handleClearField}
          markedItems={this.state.markedItems}
          revertMarked={this.revertMarked}
          onSave={this.onSave}
          addedFields={this.state.addedFields}
          isEditable={this.state.isEditable}
          onChangeValue={this.onChangeValue}
          handleEditField={this.handleEditField}
          handleSaveValue={this.handleSaveValue}
          onChangeTextField={this.onChangeTextField}
          removedFields={this.state.removedFields}
          loadingDoc={this.state.loadingDoc}
          iteratedData={this.state.iteratedData}
          isIterated={this.state.isIterated}
          editedDocScanned={this.state.editedDocScanned}
          editedFields={this.state.editedFields}
          sessionId={this.state.sessionId}
          docPrompts={this.state.docPrompts}
          handleRemoveField={this.handleRemoveField}
          handleAcceptExtraction={this.handleApproveExtraction}
          handleRejectExtraction={this.handleRejectExtraction}
          handleDeleteDocPrompt={this.handleDeleteDocPrompt}
        />

        <AddManualInputModal
          modal={this.state.modal} 
          onClose={this.handleClose} 
          onAddField={this.handleAddField} 
          handleAddField={this.handleAddField}
          manualInput={this.state.manualInput}
          handleInputChange={this.handleInputChange}
          addedFields={this.state.addedFields}
          // handleSaveManualInput={this.handleFeedbackSubmit}
          handleSaveManualInput={this.onSave}
          handleRemoveField={this.handleRemoveField}
        />

        <AddDocModal
          modal={this.state.modal}
          onClose={this.handleClose}
          onChange={this.onChangeDoc}
          fields={this.state.docFields}
          errors={this.state.docErrors}
          onSubmit={this.addDoc}
          onSubmitReq={this.onSubmitReq}
          fileType={this.state.fileType}
          addDocType={this.state.addDocType}
          attachTo={this.state.attachTo}
          onhandleChange={this.onhandleChange}
        />

        <ExtractionResultModal
          modal={this.state.modal}
          onClose={this.handleClose}
          onChange={this.onChangeExtractionResult}
          onSubmit={this.onSubmitResult}
          fields={this.state.extractionResultFields}
          errors={this.state.extractionResultErrors}
        />

        <ConfirmModalContainer />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(AnyDocContainer);

